import { FormData } from "../types";

interface VerificationStageProps {
  formData: FormData;
  isLoading: boolean;
  verificationMethod: "email" | "phone";
  onSubmit: (e: Event) => void;
  onInputChange: (e: Event) => void;
}

export const VerificationStage = ({
  formData,
  isLoading,
  verificationMethod,
  onSubmit,
  onInputChange,
}: VerificationStageProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <h2 className="text-2xl font-bold text-center">
        Verify Your {verificationMethod === "email" ? "Email" : "Phone"}
      </h2>
      <p className="text-gray-600 text-center">
        Please enter the verification code sent to your{" "}
        {verificationMethod === "email" ? "email" : "phone"}.
      </p>

      <div className="space-y-1">
        <input
          type="text"
          name="verificationCode"
          value={formData.verificationCode}
          onChange={onInputChange}
          placeholder="Enter verification code"
          className="kismet-form-input w-full border-b border-gray-300 p-2 focus:outline-none focus:border-black transition-colors text-center text-2xl tracking-wider"
          maxLength={6}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading || !formData.verificationCode}
        className={`w-full py-3 rounded-full text-base font-medium transition-colors ${
          isLoading || !formData.verificationCode
            ? "bg-gray-300 cursor-not-allowed"
            : "bg-black text-white hover:bg-gray-800"
        }`}
      >
        {isLoading ? "Verifying..." : "Verify"}
      </button>
    </form>
  );
};
